import { useOrganization } from '@foxtrotplatform/platform-micro-site-core';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { SELECTED_USER_ORG_ID } from '../../common/constants';
import { OrganizationCheck } from './OrganizationCheck';

export const OrganizationRoot: React.FunctionComponent =
  (): JSX.Element | null => {
    const navigate = useNavigate();
    const { organizations } = useOrganization();

    useEffect(() => {
      if (organizations?.length) {
        const curretOrgId = localStorage.getItem(SELECTED_USER_ORG_ID);
        const currentOrg = organizations.find(({ id }) => id === curretOrgId);
        if (currentOrg) {
          navigate(`/organization/${currentOrg.id}`);
        } else {
          navigate(`/organization/${organizations[0].id}`);
        }
      }
    }, [organizations]);

    return <OrganizationCheck />;
  };
